
import { useCallback } from 'react';
import { WizardFormData, WizardState, WizardActions } from './types';

export const useWizardStepSubmit = (
  state: WizardState,
  actions: WizardActions,
  handleNext: () => Promise<boolean>
) => {
  const { currentStep } = state;
  const { setFormData, setStepValidity } = actions;

  const handleStepSubmit = useCallback(async (stepData: Partial<WizardFormData>, isValid: boolean = true) => {
    console.log(`Step ${currentStep} submission:`, { stepData, isValid });
    
    // Update form data with the new step data
    setFormData((prevData: WizardFormData) => {
      return { ...prevData, ...stepData };
    });
    
    // Update step validity
    setStepValidity((prevValidity: Record<number, boolean>) => {
      return {
        ...prevValidity,
        [currentStep]: isValid
      };
    });
    
    // Auto-advance to next step if valid
    if (isValid && currentStep < 5) { // 5 is the last step (summary)
      await handleNext();
    }
  }, [currentStep, setFormData, setStepValidity, handleNext]);

  return { handleStepSubmit };
};
